export const removeUndefinedProps = <T extends Record<string, unknown>>(obj: T): Partial<T> => {
    const filtered: Partial<T> = {};
    Object.keys(obj).forEach((key: keyof T) => {
        if (obj[key] !== undefined) {
            filtered[key] = obj[key];
        }
    });
    return filtered;
};
